const locale = {
	VIEW_LEAVE_ITEM_RECOVERY_HOURS: 'Recupero ore: {dateRange}',
	VIEW_ITEM_LEAVE_REJECT: 'Rifiuta',
	VIEW_ITEM_LEAVE_ACCEPT: 'Accetta',

	// #region Leave fields
	DETAILS_LEAVE_FIELD_TITLE: 'Titolo',
	DETAILS_LEAVE_FIELD_STATUS: 'Stato Permesso',
	DETAILS_LEAVE_FIELD_TYPE: 'Tipo Permesso',
	DETAILS_LEAVE_FIELD_USER: 'Utente',
	DETAILS_LEAVE_FIELD_WHOLE_DAY: 'Giornata intera',
	DETAILS_LEAVE_FIELD_DATE_FROM: 'Data da',
	DETAILS_LEAVE_FIELD_DATE_TO: 'Data a',
	DETAILS_LEAVE_FIELD_TIME_FROM: 'Dalle ore',
	DETAILS_LEAVE_FIELD_TIME_TO: 'Alle ore',
	DETAILS_LEAVE_FIELD_RECOVERY_HOURS: 'Recupero ore',
	DETAILS_LEAVE_FIELD_RECOVERY_DATE_FROM: 'Recupero ore da',
	DETAILS_LEAVE_FIELD_RECOVERY_DATE_TO: 'Recupero ore a',
	DETAILS_LEAVE_FIELD_ASSIGNED_USER: 'Gestito da',
	DETAILS_LEAVE_FIELD_REJECTED_REASON: 'Motivo rifiuto',
	DETAILS_LEAVE_FIELD_TAGS: 'Tag',
	DETAILS_LEAVE_FIELD_WARNING: 'Warning',
	DETAILS_LEAVE_FIELD_BLOCKED: 'Bloccato'
	// #endregion
};

export default locale;
